/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState } from 'react';

import { Grid, Card, CardContent } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { withTranslation } from 'react-i18next';
import ContactFormComponent from '../components/Forms/ContactFormComponent';
import { SeoComponent } from '../components/Header/SeoComponent'
import { useThemeData } from '../context/ThemeDataContext'

function Contact(props) {
  const {site_name } = useThemeData().themeData.site;
  const {font_family, primary_color_2, favicon } = useThemeData().themeData.site.theme;
  const [completed, setCompleted] = useState(false);

  return (
    <Grid item lg={12} md={12}
      style={{
        fontFamily: `${font_family}`,
        color: `${primary_color_2}`
      }}>
      <SeoComponent site_name={site_name} favicon={favicon} title='Contact' />
      {!completed ?
        <Card style={{
          fontFamily: `${font_family}`,
          color: `${primary_color_2}`
        }}>
          <CardContent className="contact-text">

            <ContactFormComponent {...props} setCompleted={setCompleted} />

          </CardContent>
        </Card>
        : // message is send
        <Alert severity="success">{props.t('contact:Success')}</Alert>
      }

    </Grid>
  );
}

export default React.memo(withTranslation(['contact'])(Contact));
